import { useMutation } from 'react-query';

import { billingErrorToast } from '@components/BillingError/toast';
import { SubscriptionParams, updateCbptUserSubscription } from '@utils/backend-api/subscribe';
import { BillingErrorPayload, normalizeBillingError } from '@utils/billingErrors';
import { legacyTracking } from '@utils/tracking';

const useSubscriptionUpdateForCbpt = () => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: SubscriptionParams) => updateCbptUserSubscription(params),
    {
      onSuccess: (data) => {
        legacyTracking(data);
      },
      onError: (
        error: Partial<BillingErrorPayload> & { message?: string; redirect_to?: string }
      ) => {
        billingErrorToast(normalizeBillingError(error));
        if (error.redirect_to) {
          window.location.href = error.redirect_to;
        }
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
};

export default useSubscriptionUpdateForCbpt;
